var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessModalPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 427318449"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 95",
    cx: 40.5,
    cy: 40,
    r: 40,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 6644"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M34.8923 47.8967L26.8741 39.9102L24.2014 42.5724L34.8923 53.2211L57.8014 30.4024L55.1287 27.7402L34.8923 47.8967Z",
    fill: "#5AB52F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessModalPayment);
export default __webpack_public_path__ + "static/media/successModalPayment.c2376d451214429f744c7a52bd5e8434.svg";
export { ForwardRef as ReactComponent };